import fromPairs from "lodash/fromPairs";
import type { ReducersMapObject } from "redux";

import { createReducer } from "../../../generic/redux/createReducer";

import { getGlobalChangedActionSpecs } from "./GlobalChangedActions";
import { type GlobalState, initialGlobalState } from "./GlobalState";

function getGlobalChangedActionsReducerMap(): ReducersMapObject {
	return fromPairs(getGlobalChangedActionSpecs().map((spec) => [spec.actionName, spec.reducer]));
}

export default createReducer<GlobalState>(initialGlobalState, {
	...getGlobalChangedActionsReducerMap(),
});
